<template>
  <div><xzqhlb /></div>
</template>

<script>
import xzqhlb from '@/components/xzqh/xzqh'

export default {
  name: 'Xzqh',
  components: {
    xzqhlb
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
